import { render, staticRenderFns } from "./linkPrivyId.vue?vue&type=template&id=1b662a62&"
import script from "./linkPrivyId.vue?vue&type=script&lang=js&"
export * from "./linkPrivyId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports